// extracted by mini-css-extract-plugin
export default {"minibar":"cJGaXtR6XeLOo7Q3k62_"};